import React from 'react';
import { Typography } from 'fronton-react';
import { TTopCategory } from 'data';
import { findTopCategoryData, getTopCategoriesId, getNumberOfRenderedCategoriesRows } from 'utils';
import { CategoriesContainer } from '../categories-container';

import { TopCategory, TopCategoryTitle } from './styles';

type TopCategoriesContentProps = {
	selectedFilterItems: number[];
	topCategories: TTopCategory[];
	numberOfCardsInARow: number;
	numberOfShownRows: number;
};

/**
 * На лендинге есть фильтр
 * В фильтре можно выбрать топовые категории
 * В стор сохраняются айдишники выбранных топ категорий
 * В этом компоненте нужно определить, какие топовые категории выводить - все или те, что были выбраны в фильтре
 * (результат сохраняю в topCategoriesArray)
 * Потом выполняется обход итогового массива айдишек и вывод нужных топовых категорий
 */

export const TopCategoriesContent = ({
	selectedFilterItems,
	topCategories,
	numberOfCardsInARow,
	numberOfShownRows,
}: TopCategoriesContentProps) => {
	// сюда сохраняем количество рядов, которые уже отрендерили
	let numberOfRenderedRows = 0;

	const topCategoriesArray = selectedFilterItems.length
		? selectedFilterItems
		: getTopCategoriesId(topCategories);

	return (
		<>
			{topCategoriesArray.map((topCategoryId, i) => {
				if (i === 0) {
					numberOfRenderedRows = 0; //	при каждом новом рендере обнуляем счетчик
				}
				const topCategoryData = findTopCategoryData(topCategories, topCategoryId);

				const numberOfNewRows = getNumberOfRenderedCategoriesRows(
					topCategoryData,
					numberOfShownRows,
					numberOfCardsInARow,
					numberOfRenderedRows
				);

				numberOfRenderedRows += numberOfNewRows;

				return (
					<TopCategory
						key={`top-category-wrapper-${topCategoryId}`}
						isVisible={numberOfNewRows > 0}
						data-qa={`top-category-wrapper-${topCategoryId}`}
					>
						<Typography variant="h2" as="h2" className={TopCategoryTitle}>
							{topCategoryData.topCategoryName}
						</Typography>
						<CategoriesContainer
							topCategoryData={topCategoryData}
							numberOfAvailableRenderedCards={numberOfNewRows * numberOfCardsInARow}
						/>
					</TopCategory>
				);
			})}
		</>
	);
};
